import React from "react";
import styles from "./PreviewAdd.module.scss";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

export function PreviewAdd(props: { createNewPreview: () => void }) {
  return (
    <div className={styles.newPreview} onClick={props.createNewPreview}>
      <div className={styles.button}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#0A9DFF" />
          <path d="M10 15V5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M15 10H5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

        <div className={styles.text}>Add a Publish Format</div>
        <img
          className={styles.right_icon}
          src={`${settings.S3CDN}${settings.viewAssetsPath}dropdown-right.svg`}
          alt="icon"
        />
      </div>
    </div>
  );
}
